export default __webpack_public_path__ + "static/media/milena_l.5628a3c6.jpg";